import { Company } from 'interfaces/company'
import BillingAddressModal from './billing-address-modal'
import { useState } from 'react'

export default function BillingAddress({
  company,
  setCompany,
}: {
  company: Company
  setCompany: (company: Company) => void
}) {
  const [openModal, setOpenModal] = useState(false)
  const stateAndZip = company.state ? `${company.state} ${company.zip}` : company.zip
  const addressLine = company.address2 ? `${company.address1}, ${company.address2}` : company.address1
  const address = `${addressLine}, ${company.city}, ${stateAndZip}, ${company.country}`

  return (
    <>
      <div className="tw-block tw-h-24 tw-w-full tw-rounded-lg tw-bg-white tw-p-4 tw-shadow-md">
        <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">
          <strong>Billing Address</strong>
          <div
            className="tw-text-squash-600 tw-cursor-pointer tw-text-cornflower-500 hover:tw-underline"
            onClick={() => setOpenModal(true)}
          >
            Update address
          </div>
        </div>
        <div>{address}</div>
      </div>
      <BillingAddressModal company={company} open={openModal} setOpen={setOpenModal} setCompany={setCompany} />
    </>
  )
}
